import { AxiosBookings, userId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";

export const incidentRequestApiFactory = {
  $_getAllIncidents() {
    let url = `/assistanceRequests/find-user-assistance-requests/${userId()}`;
    return AxiosBookings.get(url);
  },
  $_createDomain(payload) {
    const url = `/domains`;
    return AxiosBookings.post(url, payload);
  },
  $_deleteDomain(email) {
    const url = `/domains/remove-subdomain?email=${email}`;
    return AxiosBookings.delete(url);
  },
  $_updateDomain(payload) {
    const url = `/domains/update-subdomain`;
    return AxiosBookings.patch(url, payload);
  },
  $_setDefaultDomain(locationId) {
    const url = `/domains/setdefault/${locationId}`;
    // const userId = localStorage.getItem("userId");
    // const payload = {
    //   userId: userId,
    // };
    return AxiosBookings.patch(url);
  },
  $_newGetAllIncidents(params) {
    let url = `/incident-reports${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
    $_newGetAllRequests() {
    let url = `/request-assistance`;
    return AxiosBookings.get(url);
  },
  $_incedentById(id) {
    let url = `/shippings/timeline/${id}`;
    return AxiosBookings.get(url);
  },
  $_requestById(id) {
    let url = `/request-assistance/${id}`;
    return AxiosBookings.get(url);
  },
    $_incedenttimelineById(id) {
    let url = `/incident-reports/incident-timeline/${id}`;
    return AxiosBookings.get(url);
  },
  $_updateRequestAssitance(id, payload){
    let url = `/request-assistance/${id}`;
    return AxiosBookings.patch(url, payload);
  },
   $_updateIncident(id, payload){
    let url = `/incident-reports/update-incident/${id}`;
    return AxiosBookings.patch(url, payload);
  }
};
